import { handleActions } from 'redux-actions'
import update from 'immutability-helper'

import {
  REQUEST_STAGE_ELEMENTS,
  RECEIVE_STAGE_ELEMENTS,
  CREATE_STAGE_ELEMENT,
  GET_AVAILABLE_EQUIPMENT_TYPES,
  REQUEST_SEARCH_RESULTS,
  RECEIVE_SEARCH_RESULTS
} from '../actions/stage-elements'

export default handleActions({
  [REQUEST_STAGE_ELEMENTS]: (state, action) => {
    return update(state, {
      isFetching: {$set: true}
    })
  },
  [RECEIVE_STAGE_ELEMENTS]: (state, action) => {
    let { list } = action.payload.data

    const drums = [
      {id: 'kickdrum', title: 'Kick drum', type: {title: 'Drums', slug: 'drums'}},
      {id: 'snaredrum', title: 'Snare drum', type: {title: 'Drums', slug: 'drums'}},
      {id: 'racktom', title: 'Rack tom', type: {title: 'Drums', slug: 'drums'}},
      {id: 'floortom', title: 'Floor tom', type: {title: 'Drums', slug: 'drums'}},
      {id: 'ohl', title: 'OH L', type: {title: 'Drums', slug: 'drums'}},
      {id: 'overheadleft', title: 'Overhead - left', type: {title: 'Drums', slug: 'drums'}},
      {id: 'ohr', title: 'OH R', type: {title: 'Drums', slug: 'drums'}},
      {id: 'overheadr', title: 'Overhead - right', type: {title: 'Drums', slug: 'drums'}}
    ]

    const stageplanItems = [
      {
        id: null,
        title: "Stage elements",
        type: {
          title: "Custom",
          slug: "custom"
        },
        children: [
          {
            id: null,
            title: "Piano Chair",
            type: {
              title: "Custom",
              slug: "custom"
            },
            width: 50,
            height: 50
          },
          {
            id: null,
            title: "Carpet",
            type: {
              title: "Custom",
              slug: "custom"
            },
            width: 150,
            height: 150
          },
          {
            id: null,
            title: "Risers",
            type: {
              title: "Custom",
              slug: "custom"
            },
            width: 150,
            height: 100
          },
          {
            id: null,
            title: "Notestand",
            type: {
              title: "Custom",
              slug: "custom"
            },
            width: 100,
            height: 25,
            rotation: {
              degrees: '-90',
              radians: '-1.57'
            }
          },
          {
            id: null,
            title: "Chair",
            type: {
              title: "Custom",
              slug: "custom"
            },
            width: 50,
            height: 50
          }
        ]
      },
      {
        id: null,
        title: "Electricity",
        type: {
          title: "Custom",
          slug: "custom"
        },
        children: [
          {
            id: null,
            title: "220V",
            type: {
              title: "Custom",
              slug: "custom"
            },
            width: 100,
            height: 25,
            rotation: {
              degrees: '-90',
              radians: '-1.57'
            }
          },
          {
            id: null,
            title: "110V",
            type: {
              title: "Custom",
              slug: "custom"
            },
            width: 100,
            height: 25,
            rotation: {
              degrees: '-90',
              radians: '-1.57'
            }
          },
          {
            id: null,
            title: "Di-box",
            type: {
              title: "Custom",
              slug: "custom"
            },
            width: 100,
            height: 25,
            rotation: {
              degrees: '-90',
              radians: '-1.57'
            }
          }
        ]
      },
      {
        id: null,
        title: "Accessories",
        type: {
          title: "Custom",
          slug: "custom"
        },
        children: [
          {
            id: null,
            title: "Cable",
            type: {
              title: "Custom",
              slug: "custom"
            },
            width: 200,
            height: 25,
            rotation: {
              degrees: '-90',
              radians: '-1.57'
            }
          },
          {
            id: null,
            title: "Stand/Boom",
            type: {
              title: "Custom",
              slug: "custom"
            },
            width: 25,
            height: 100,
            rotation: {
              degrees: '-90',
              radians: '-1.57'
            }
          },
          {
            id: null,
            title: "Snake",
            type: {
              title: "Custom",
              slug: "custom"
            },
            width: 25,
            height: 25
          }
        ]
      },
      {
        id: null,
        title: "Character",
        type: {
          title: "Custom",
          slug: "custom"
        },
        children: [
          {
            id: null,
            title: "Artist",
            type: {
              title: "Custom",
              slug: "custom"
            },
            width: 100,
            height: 100,
            shape: 'oval'
          },
          {
            id: null,
            title: "Conductor",
            type: {
              title: "Custom",
              slug: "custom"
            },
            width: 100,
            height: 100,
            shape: 'oval'
          },
          {
            id: null,
            title: "Dancer",
            type: {
              title: "Custom",
              slug: "custom"
            },
            width: 100,
            height: 100,
            shape: 'oval'
          }
        ]
      },
      {
        id: null,
        title: "Cabinets/Amps",
        type: {
          title: "Custom",
          slug: "custom"
        },
        children: [
          {
            id: null,
            title: "Leslie Cabinet",
            type: {
              title: "Custom",
              slug: "custom"
            },
            width: 100,
            height: 25,
            rotation: {
              degrees: '-90',
              radians: '-1.57'
            }
          },
          {
            id: null,
            title: "Keyboard Amp",
            type: {
              title: "Custom",
              slug: "custom"
            },
            width: 100,
            height: 25,
            rotation: {
              degrees: '-90',
              radians: '-1.57'
            }
          },
          {
            id: null,
            title: "Guitar Amp",
            type: {
              title: "Custom",
              slug: "custom"
            },
            width: 100,
            height: 25,
            rotation: {
              degrees: '-90',
              radians: '-1.57'
            }
          },
          {
            id: null,
            title: "Bass Amp",
            type: {
              title: "Custom",
              slug: "custom"
            },
            width: 100,
            height: 25,
            rotation: {
              degrees: '-90',
              radians: '-1.57'
            }
          },
          {
            id: null,
            title: "Cabinet",
            type: {
              title: "Custom",
              slug: "custom"
            },
            width: 100,
            height: 25,
            rotation: {
              degrees: '-90',
              radians: '-1.57'
            }
          }
        ]
      },
      {
        id: null,
        title: "Electronics",
        type: {
          title: "Custom",
          slug: "custom"
        },
        children: [
          {
            id: null,
            title: "Computer",
            type: {
              title: "Custom",
              slug: "custom"
            },
            width: 50,
            height: 50
          },
          {
            id: null,
            title: "Head Unit",
            type: {
              title: "Custom",
              slug: "custom"
            },
            width: 50,
            height: 50
          },
          {
            id: null,
            title: "Microphone",
            type: {
              title: "Custom",
              slug: "custom"
            },
            width: 50,
            height: 50
          },
          {
            id: null,
            title: "Headphones",
            type: {
              title: "Custom",
              slug: "custom"
            },
            width: 50,
            height: 50
          },
          {
            id: null,
            title: "Earphones",
            type: {
              title: "Custom",
              slug: "custom"
            },
            width: 50,
            height: 50
          }
        ]
      }
    ]

    const mapGroupsToEquipmentTypes = (groups) => {
      const equipmentTypes = []

      Object.keys(groups).forEach(equipmentType => {
        if (equipmentType !== 'instrument') equipmentTypes.push(groups[equipmentType])
      })

      return equipmentTypes
    }

    state = update(state, {$merge: list})

    state = update(state, {
      isFetching: {$set: false},
      groups: {
        instrument: {
          $merge: {groups: {drums}}
        }
      },
      instrument: {
        $push: drums
      },
      equipmentTypes: {$set: mapGroupsToEquipmentTypes(list.groups)},
      stageplanItems: {$set: stageplanItems}
    })

    return state
  },
  [CREATE_STAGE_ELEMENT]: (state, action) => {
    return state
  },
  [GET_AVAILABLE_EQUIPMENT_TYPES]: (state, action) => {
    const { availableColumnTypes } = action.payload

    state = update(state, {
      availableColumnTypes: {$set: availableColumnTypes}
    })

    return state
  },
  [REQUEST_SEARCH_RESULTS]: (state, action) => {
    const { term } = action.payload

    return update(state, {
      search: {$set: {
        results: undefined,
        term
      }}
    })
  },
  [RECEIVE_SEARCH_RESULTS]: (state, action) => {
    const { term, results } = action.payload

    return update(state, {
      search: {$set: {
        results,
        term
      }}
    })
  }
}, {})



// WEBPACK FOOTER //
// ./src/reducers/stage-elements.js